export const handleFilterChange = (type, value, setFilter) => {
  setFilter((prevState) => ({ ...prevState, [type]: value, page: 1 }));
};
